import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useEcptPermissions } from '../utils/ecptPermissions';
import { authService } from '../services/authService';
import { tokenStorage } from '../utils/tokenStorage';
import { store } from '../../store';

interface EcptRoleProtectedRouteProps {
  children: ReactNode;
}

const EcptRoleProtectedRoute = ({ children }: EcptRoleProtectedRouteProps) => {
  const { hasAccess } = useEcptPermissions();
  const location = useLocation();
  const [verified, setVerified] = useState<boolean | null>(null);

  useEffect(() => {
    const verify = async () => {
      const profile = store.getState().ssoUser?.profile;
      const accessToken = tokenStorage.getAccessToken();

      if (!profile || !accessToken) {
        setVerified(false);
        return;
      }

      try {
        const result = await authService.verifyProfile(accessToken, profile);
        setVerified(result.integrity_valid);
      } catch {
        setVerified(false);
      }
    };

    verify();
  }, []);

  // Still loading the integrity check
  if (verified === null) return null;

  const basePath = location.pathname.includes('/mopsc-app-station-v3/')
    ? '/mopsc-app-station-v3/home'
    : location.pathname.includes('/mopsc-app-station-v2/')
      ? '/mopsc-app-station-v2/home'
      : '/mopsc-app-station/home';

  if (!verified || !hasAccess) {
    return <Navigate to={basePath} replace />;
  }

  return <>{children}</>;
};

export default EcptRoleProtectedRoute;
